import './Loaders.css'

function Loaders(){
    return(
        <div className='spinner-container'>
        <div className="spinner"></div>
        <h1>djStayle</h1>
        </div>
    )

}
export default Loaders